import { createContext } from 'react';
import { initialFormValues } from './InitialFormValues';
/*
 * Initialize context with associated states & functions
 *
 * The acutal values of the context get set within the Form.Provider.js within the
 * return of the file where value is passed to the <FormContext.Provider/>
 *
 * When adding values to the Context, be sure to update:
 * 1. Form.context.js
 * 2. Form.provider.js - to implement the function with the reducer and to add the state/value to the "return" section
 * 3. Reducer.js - if any state management is required
 */
export const FormContext = createContext({
    formValues: { ...initialFormValues },
    memberDetails: {},
    populationConfig: {},
    noMemberFound: false,
    allProvidersPool: [],
    estimateResponse: {},
    singleEstimateResponse: {},
    visionEstimateResponse: {},
    integrationType: 'member',
    sourceSystem: 'epe', // defaulting to epe
    rxToggle: true,
    showErrorPage: false,
    searchCount: 0,
    planBenefits: {},
    isPreventive: false,
    estimateResultsPage: 0,
    handleChange() {},
    validateFormFieldsOnSubmit() {},
    handleChangeCustom() {},
    handleReset() {},
    validateFormData() {},
    disableNextButton() {},
    setIntegrationType() {},
    setRxToggle() {},
    setSourceSystem() {},
    setSingleEstimateResponse() {},
    setVisionEstimateResponse() {},
    setEstimateResponse() {},
    setAllProvidersPool() {},
    updateIsErrorPageVisible() {},
    incrementSearchCount() {},
    getIncrementedCorId() {},
    getCorID() {},
    setNoMemberFound() {},
    addMemberDetailsToContext() {},
    setCpttCorrelationId() {},
    sanitizeMemberFormData() {},
    setPlanBenefits() {},
    setIsPreventive() {},
    clearPreventiveFlags() {},
    clearEstimateHistory() {},
    setEstimateResultsPage() {},
});
